<template>
  <div>
    <h2>
      For a basic example, consider the watch property
      <i>Kilometer &lt;-&gt; Meter conversion</i>:
    </h2>
    <pre>
          <code>&lt;template&gt;
&lt;v-card light&gt;
    &lt;v-container&gt;
      &lt;v-row&gt;
        &lt;v-col cols="12" md="6"&gt;
          &lt;v-text-field
            v-model="kilometers"
            label="Enter the value for kilometer"
          &gt;&lt;/v-text-field&gt;
        &lt;/v-col&gt;
        &lt;v-col cols="12" md="6"&gt;
          &lt;v-text-field v-model="meters" label="Enter the value for meter"&gt;&lt;/v-text-field&gt;
        &lt;/v-col&gt;
      &lt;/v-row&gt;
    &lt;/v-container&gt;
  &lt;/v-card&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  name: "meter-conversion", 
  data() {
    return {
      kilometers : 0,  
      meters:0 
    }
  },
  watch : {  
    kilometers(val) {  
      this.kilometers = val;  
      this.meters = val * 1000;  
    },  
    meters (val) {  
      this.kilometers = val/ 1000;  
      this.meters = val;  
    }  
  }  
};
&lt;/script&gt;</code>
        </pre>

    <h2>Output</h2>
    <br />
    <v-card light>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="kilometers"
              label="Enter the value for kilometer"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="meters" label="Enter the value for meter"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "meter-conversion",
  data() {
    return {
      kilometers: 0,
      meters: 0,
    };
  },
  watch: {
    kilometers(val) {
      this.kilometers = val;
      this.meters = val * 1000;
    },
    meters(val) {
      this.kilometers = val / 1000;
      this.meters = val;
    },
  },
};
</script>
